<!--
 * @Author: zb
 * @LastEditors: 请在根目录下.vscode改成你的名字
 * @Date: 2019-08-08 19:37:58
 * @LastEditTime: 2019-09-29 16:25:55
 * @Version: 1.0
 * @Description: 物流监控页面
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->
<template>
  <article class="map-box" :class="{'full': isFull}">
    <z-map
      v-loading="loading"
      :lines="lines"
      :markers="markers"
      :window-infos="windows"
      :data="data"
      element-loading-text="绘制中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      @complete="complete"
    />
    <div class="simple">
      <ul>
        <li>
          <div>
            <svg height="100%" width="100%" viewBox="0 0  48 12">
              <rect x="0" y="0" height="24" width="9.6" :fill="lineColors.water" />
              <rect x="19.2" y="0" height="24" width="9.6" :fill="lineColors.water" />
              <rect x="38.4" y="0" height="24" width="9.6" :fill="lineColors.water" />
            </svg>
          </div>
          <span>水路运输</span>
        </li>
        <li>
          <div>
            <svg height="100%" width="100%" viewBox="0 0  48 12">
              <rect x="0" y="0" height="24" width="9.6" :fill="lineColors.train" />
              <rect x="19.2" y="0" height="24" width="9.6" :fill="lineColors.train" />
              <rect x="38.4" y="0" height="24" width="9.6" :fill="lineColors.train" />
            </svg>
          </div>
          <span>铁路运输</span>
        </li>
        <li>
          <div>
            <svg height="100%" width="100%" viewBox="0 0  48 12">
              <rect x="0" y="0" height="24" width="9.6" :fill="lineColors.pip" />
              <rect x="19.2" y="0" height="24" width="9.6" :fill="lineColors.pip" />
              <rect x="38.4" y="0" height="24" width="9.6" :fill="lineColors.pip" />
            </svg>
          </div>
          <span>管道运输</span>
        </li>
        <li>
          <div />
          <span>公路运输</span>
        </li>
      </ul>
    </div>
    <div id="expand" title="缩放地图" @click="switchMap">
      <i :class="{'el-icon-top-left': !isFull, 'el-icon-bottom-right': isFull}" />
    </div>
  </article>
</template>
<script>
import begin from '@/assets/img/monitor/begin.png'
import end from '@/assets/img/monitor/end.png'
import car from '@/assets/img/monitor/zhongTu.png'
import {
  queryPoint,
  drawRoute,
  queryLngLat,
  changeLngLatToPoint
} from './UtilMethods'
// import getImg from '@/filters/getImg'
import ZMap from './ZMap'
const replaceEmpty = function(val) {
  return (!val || val === 'null' || val === '') ? '无' : val
}

const lineColors = {
  pip: '#079B4B',
  water: '#0ba5e4',
  train: '#0d50a0',
  road: '#FA5500'
}
const showWindow = (e, wb, content) => {
  const selectedInfo = wb
  const curColor = wb.transportType == '1'
    ? lineColors.road
    : wb.transportType == '2'
      ? lineColors.train
      : wb.transportType == '3'
        ? lineColors.water
        : lineColors.pip
  const html = `<div class="info">
                          <div class="header">
                              <div> 运单编号 : ${replaceEmpty(selectedInfo.tsOrderNum)}</div>
                          </div>
                          <div class="body">
                              <div > 运输方式 : <span style='color:${curColor}'>${selectedInfo.transportTypeLabel}运输<span></div>
                              <div> 起运地 : ${replaceEmpty(selectedInfo.startPlace)}</div>
                              <div> 目的地 : ${replaceEmpty(selectedInfo.stopPlace)}</div>
                              <div> 起运时间 : ${replaceEmpty(selectedInfo.startSportDate)}</div>
                              <div>
                                <div class="body-float">货物名称 : ${replaceEmpty(selectedInfo.goodsName)}</div>
                                <div class="body-float">货物重量 : ${replaceEmpty(selectedInfo.weight)}吨</div>
                              </div>

                              <div> 承运单位 : ${replaceEmpty(selectedInfo.transportCompany)}</div>
                              <div>
                                <div class="body-float">联系人 : ${replaceEmpty(selectedInfo.transportPerson)}</div>
                                <div class="body-float">联系电话 : ${replaceEmpty(selectedInfo.transportTel)}</div>
                              </div>

                              <div class="line-info">
                                此货物目前正在${String(selectedInfo.startPlace).replace(/\//g, '')}预计${selectedInfo.stopSportDate}到达${String(
  selectedInfo.stopPlace
).replace(/\//g, '')}
                              </div>
                          </div>
                        </div>
  `
  content.windows.push({
    position: changeLngLatToPoint(e.lnglat),
    content: html
  })
}

export default {
  name: 'WayBillTrajectoty',
  components: {
    ZMap
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    isDev: { // 是否是开发模式， 是的话自动画图
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      lines: [],
      markers: [],
      windows: [],
      isFull: false,
      loading: false,
      lineColors: {
        pip: '#079B4B',
        water: '#0ba5e4',
        train: '#0d50a0',
        road: '#FA5500'
      }
    }
  },
  // 数据变化的时候重新绘制地图
  watch: {
    data: function(val, oldVal) {
      if (val && Object.keys(val).length !== 0 && oldVal != val) {
        this.repaint()
      }
    }
  },
  created: async function() {
    if (Object.keys(this.data).length > 1) {
      this.createData()
    }
  },
  mounted: function() {},
  methods: {
    // 控制地图放大和缩小
    switchMap() {
      this.isFull = !this.isFull
    },
    // 绘制完成
    complete() {
      this.loading = false
    },
    // 重绘地图
    repaint() {
      this.lines = []
      this.markers = []
      this.windows = []
      this.createData()
    },
    // 根据具体业务处理数据生成地图需要的数据
    async createData() {
      this.loading = true
      // 生成订单起始点和结束点的marker
      await queryPoint([
        String(this.data.startPlace).replace(/\//g, ''),
        String(this.data.stopPlace).replace(/\//g, '')
      ]).then(data => {
        const [start, stop] = data
        this.markers.push({
          point: start,
          icon: begin
        })
        this.markers.push({
          point: stop,
          icon: end
        })
      })

      // 根据运单生成运单路线和车辆和路线中间的图标
      for (const wb of this.data.wayBill) {
        const start = { lng: null, lat: null }
        const stop = { lng: null, lat: null } // 运单的起点和终点

        // 先转换一下吧， 不然自动规划路线的时候， 坐标格式不对
        // await queryLngLat([
        //   String(wb.startPlace).replace(/\//g, ''),
        //   String(wb.stopPlace).replace(/\//g, '')
        // ]).then(data => {
        //   [start, stop] = data
        // })

        if (wb.startLonLat) {
          [start.lng, start.lat] = wb.startLonLat.split(',').map(item => Number.parseFloat(item))
        }

        if (wb.stopLonLat) {
          [stop.lng, stop.lat] = wb.stopLonLat.split(',').map(item => Number.parseFloat(item))
        }
        // 路线的配置参数
        const lineConfig = {
          events: {
            click: (e) => showWindow(e, wb, this)
          },
          strokeColor:
              wb.transportType == '1'
                ? lineColors.road
                : wb.transportType == '2'
                  ? lineColors.train
                  : wb.transportType == '3'
                    ? lineColors.water
                    : lineColors.pip
        }

        if (wb.transportType == '1') {
          // 通过高德工具方法规划车辆的路径， 主要是获取运单起点到终点的点集合
          if (this.isDev) {
            await drawRoute([start.lng, start.lat], [stop.lng, stop.lat]).then(path => {
              const points = changeLngLatToPoint(path)
              Object.assign(lineConfig, {
                path: points,
                strokeStyle: 'solid',
                strokeWeight: 8,
                strokeOpacity: 0.8,
                cursor: 'pointer',
                lineJoin: 'round',
                extData: this.data
              })
            })
          } else {
            // 根据后台传的点绘线
            if (wb.points) {
              Object.assign(lineConfig, {
                path: changeLngLatToPoint(wb.points[wb.points.length - 1]),
                strokeStyle: 'solid',
                strokeWeight: 8,
                strokeOpacity: 0.8,
                cursor: 'pointer',
                lineJoin: 'round',
                extData: this.data
              })
            }
          }
          const cm = { icon: car }
          // 根据2点之间的坐标自动规划路线
          this.markers.push(
            Object.assign(cm, {
              point: changeLngLatToPoint(start)
            })
          )
          // }
        } else {
          Object.assign(lineConfig, {
            path: changeLngLatToPoint([start, stop]),
            strokeStyle: 'dashed',
            strokeWeight: 8,
            strokeOpacity: 0.8,
            cursor: 'pointer',
            lineJoin: 'round',
            strokeDasharray:
               wb.transportType == '2'
                 ? [5, 5]
                 : wb.transportType == '3'
                   ? [6, 3, 6]
                   : [1, 6, 1]
          })
        }
        this.lines.push(lineConfig)
      }
      this.complete()
    }
  }
}
</script>

<style lang="scss" scoped>
.map-box {
  .amap-box{
    transition: all 1s;
  }
  position: relative;
  height: 100%;
  &.full {

    .amap-box {
      z-index: 3000;
      position: fixed !important;
      top: 0;
      left: 0;
      height: 100%;
      height: 100%;
      transition: all 1s;
    }
    .simple{
       z-index: 3001 !important;
    }
  }
  .simple {
    position: absolute;
    background-color: white;
    border: 1px solid #ccc;
    right: 12px;
    bottom: 12px;
    z-index: 1000;
    width: 120px;
    padding: 8px 8px;
    ul {
      position: relative;
      width: 100%;
      li {
        height: 24px;
        margin: 6px 0px;
        line-height: 24px;
        div {
          position: relative;
          width: 40%;
          margin-right: 4px;
          float: left;
          height: 12px;
          top: 6px;
          bottom: 6px;
          svg {
            position: relative;
            bottom: 6px;
          }
        }
      }
      li:nth-child(4) {
        div {
          background-color: #fa5500;
        }
      }
    }
  }

  #expand {
    position: fixed;
    right: 8px;
    top: calc(50% - 24px);
    height: 48px;
    width: 48px;
    z-index: 3002;
    font-size: 24px;
    text-align: center;
    background-color: white;
    cursor: pointer;
    border-radius: 2px;
    box-sizing: border-box;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.23);
    padding: 12px 12px;
    transition: all .5s;
    &:hover {
      background-color: #3e55b4;
      transition: all .5s;
    }
  }
  .amap-box {
    border: 1px solid #bfbfbf;
    width: 100%;
    height: 100%;
  }
}
</style>
<style lang="scss">
.my_color{
  white-space: nowrap;
  top: - 24px;
}
.amap-info-content{
  background-color: rgba(255, 255, 255, 0.9);
}
.info {
  border-radius: 4px;
  // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  width: 400px;
  /*background-color: rgba(255, 255, 255, 0.8);*/
  padding: 6px 12px 12px 12px;
  .header {
    height: 24px;
    width: 100%;
    // padding-bottom: 6px;
    font-size: 15px;
    font-weight: bold;
    // border-bottom: 1px dashed #ccc;
    > div:first-child {
      color: #adadad;
      height: 24px;
      line-height: 24px;
      // font-size: 14px;
    }
    // > div:last-child {
    //   height: 24px;
    //   line-height: 24px;
    //   font-size: 14px;
    //   > span:first-child {
    //     color: #ff6525;
    //     float: left;
    //     font-size: 14px;
    //   }
    //   > span:last-child {
    //     float: right;
    //   }
    // }
  }
  .body {
    min-height: 92px;
    padding-top: 8px;
    font-weight: bold;
    color: #474747;
    >div{
      font-size: 15px;
      height: 18px;
      line-height: 18px;
      margin-bottom: 7px;
      .body-float{
        float: left;
        width: 50%;
      }
    }
    .logo {
      float: left;
      height: 92px;
      width: 48px;
      border-radius: 24px;
      margin-right: 12px;
      > img {
        height: 48px;
        width: 100%;
      }
    }
    ul {
      list-style: none;
      li {
        height: 24px;
        line-height: 24px;
      }
    }
    .line-info {
      min-height: 48px;
      padding-top: 12px;
      box-sizing: border-box;
      color: #b6412e;
      text-align: left;
    }
  }
}
</style>
